/* eslint-disable max-lines */
/* eslint-disable complexity */
import AccordionCard from '@tcp/core/src/components/common/molecules/AccordionCard/view/AccordionCard';
import PropTypes from 'prop-types';
import GIFT_SERVICES_CONSTANTS from '@tcp/core/src/components/features/CnC/Checkout/organisms/ShippingPage/molecules/GiftServices/GiftServices.constants';
import React, { useRef, useEffect, useState } from 'react';
import {
  getIconPath,
  isMobileWeb,
  getSessionStorage,
  removeSessionStorage,
} from '@tcp/core/src/utils';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  REG_FORM_MODE,
  SHIPPING_FORM_NAME,
} from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/Shipping/Shipping.constants';
import { scrollAccordionCardIntoView } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.utils';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import AddressVerification from '../../../../../common/organisms/AddressVerification/container/AddressVerification.container';
import { ADDRESS_FORM_MODE } from '../../container/Shipping/Shipping.constants';
import {
  formatPayloadForMelissa,
  setShippingFormValuesInSS,
  isAddressSaved,
} from '../../container/Shipping/Shipping.utils';
import {
  ACCORDION_REF,
  SECTION_MODE,
  SPC_SECTION,
} from '../../container/SinglePageCheckout.constants';
import ShippingCardSkeleton from './ShippingCardSkeleton.view';
import { isShippingSectionFilled } from '../../container/SinglePageCheckout.utils';
import ShippingCollapsed from './ShippingCollapsed';
import ShippingExpanded from './ShippingExpanded';
import ShippingHeader from './ShippingHeader';
import { SPC_SECTION_TRANSITION_CONFIG } from '../../../../../common/molecules/AccordionCard/hooks/useAccordionTransition.constants';
import styles from './styles/Shipping.styles';
import { handleShakeSaveAndContinueOnSpc, parseBoolean } from '../../../../../../utils/utils';
import ShippingLabels from './Shipping.labels';
import InputCheckbox from '../../../../../common/atoms/InputCheckbox';
import { getInitialValues } from '../ShippingForm/ShippingForm.view';
import { readCookie } from '../../../../../../utils/cookie.util';

const HeaderComponent = (props) => {
  const {
    section,
    savedAddress,
    updateSectionState,
    handleEdit,
    handleCancel,
    venmoPayInProgress,
    isExpanded,
    isGuestUser,
    isPlccIC,
    addressFormLabels,
    bossSwitchEnabled,
  } = props;
  const globalLabelsObj = getLabelFromCopyOrFromTranslation('global', ShippingLabels);

  const checkoutLabels = getLabelFromCopyOrFromTranslation('checkout', ShippingLabels);
  const venmoIcon = getIconPath('venmo-logo-blue');
  return (
    <>
      {venmoPayInProgress && isExpanded && !isPlccIC && (
        <div className="venmo-description">
          <Image
            src={venmoIcon}
            alt={renderLabel(globalLabelsObj?.accessibility?.lbl_info_icon, 'lbl_info_icon')}
            className="venmo-icon"
          />
          <div className="venmo-text">
            {renderLabel(
              checkoutLabels?.pickup?.lbl_pickup_venmo_banner,
              'lbl_pickup_venmo_banner'
            )}
          </div>
        </div>
      )}
      {isPlccIC ? (
        <div className="change-shipping-title">
          <BodyCopy component="span" fontWeight="extrabold" fontSize="fs20" fontFamily="secondary">
            {renderLabel(
              globalLabelsObj?.addEditAddress?.lbl_change_shipping_address,
              'lbl_change_shipping_address'
            )}
          </BodyCopy>
        </div>
      ) : (
        <ShippingHeader
          addressFormLabels={addressFormLabels}
          isPlccIC={isPlccIC}
          section={section}
          savedAddress={savedAddress}
          updateSectionState={updateSectionState}
          handleEdit={handleEdit}
          handleCancel={handleCancel}
          isGuestUser={isGuestUser}
          bossSwitchEnabled={bossSwitchEnabled}
        />
      )}
    </>
  );
};

const getIsDefaultChanged = (defaultAddress, shippingFormInput) => {
  return (
    defaultAddress &&
    defaultAddress === (shippingFormInput && shippingFormInput.addressId) &&
    !shippingFormInput.defaultShipping
  );
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const Shipping = (props) => {
  const {
    className,
    isGuestUser,
    formName,
    section,
    shippingFormInput,
    pristine,
    dirty,
    invalid,
    addressFormLabels,
    fillFormOnEdit,
    shipmentMethods,
    selectedShipmentId,
    loadShipmentMethods,
    updateShipmentMethods,
    updateSectionState,
    giftWrapOptions,
    labels,
    saveAddressFromMelissa,
    giftServicesInput,
    triggerFormSubmit,
    giftServicesLabels,
    savedAddress,
    savedGiftService,
    globalLabels,
    saveBtnLoadingStatus,
    activateSpcSection,
    recalibrateSectionStates,
    nonCacheBagLoading,
    orderEddDates,
    venmoPayInProgress,
    shippingMethodSelected,
    venmoLabels,
    ShippingFormRef,
    setCheckoutClientError,
    cartOrderItems,
    sfsError,
    dispatchFormFieldChange,
    setSFSErrors,
    dispatchGiftFormFieldChange,
    addSFSItemsToSFL,
    isLoginV2FlowEnabled,
    isLoadingShippingMethods,
    isUpdatingShipmentMethods,
    clickedOutsideShippingFlag,
    isPlccIC,
    plccShippingAddressUpdateActn,
    handleSaveAndContinueShipping,
    holidayMessageEnabled,
    isGiftServiceVisible,
    isGcEnabledOnBagSection,
    shouldShowShipmentMethodsCollapsed,
    bossSwitchEnabled,
    shippingReduxForm,
    clickedOutsideShipping,
    isMakeDefaultUxUpdateEnabled,
    freeShippingThershold,
    shippingTotal,
    isDynamicFreeShippingEnabled,
    shipments,
    orderType,
    productTotal,
    contactFormData,
    orderTrackingEnhancementEnabled,
    smsSignUpLabels,
    isSmsSignedUp,
    isInternationalPhoneNumberEnabled,
    verifyAddressAction,
    isAddressVerificationBadgeEnabled,
    smsPhoneCountryCode,
    setPhoneCountryAction,
    setSMSUpdatesAction,
    smsUpdatesAPIOptimization,
    isSMSUpdatesSingleOptInEnabled,
    isShippingMethodsOnShippingEnabled,
    isShowShipmentMethodInCollapsed,
  } = props;
  const isSmsCheckboxChecked =
    contactFormData?.smsSignUp?.sendOrderUpdate || isSmsSignedUp?.smsSignUp?.sendOrderUpdate;
  useEffect(() => {
    setShippingFormValuesInSS({ smsSignUp: { sendOrderUpdate: isSmsCheckboxChecked } });
  }, []);
  useEffect(() => {
    setPhoneCountryAction(savedAddress.phoneCountryCode || '+1');
  }, [savedAddress]);
  const [defaultAddress, makeDefaultAddress] = useState(false);
  const [smsCheckBoxState, setSMSCheckBoxState] = useState(isSmsCheckboxChecked);
  const [openFormForVerification, setOpenFormForVerification] = useState(false);
  const handleClickOutside = () => {
    handleShakeSaveAndContinueOnSpc(clickedOutsideShipping, true);
  };
  const { isExpanded, registeredUserFormMode } = section;

  useEffect(() => {
    setSMSCheckBoxState(contactFormData?.smsSignUp?.sendOrderUpdate);
  }, [isExpanded]);

  const handleChange = async () => {
    await setSMSCheckBoxState(!smsCheckBoxState);
  };

  const handleChangeWithApiCall = async () => {
    const checkBoxState = !contactFormData?.smsSignUp?.sendOrderUpdate;
    await setSMSCheckBoxState(!smsCheckBoxState);
    const shippingMethodId = selectedShipmentId;
    const values = getInitialValues(props, shippingMethodId);
    const shipMethods = { ...values.shipmentMethods, shippingMethodId };
    const updatedValues = {
      ...values,
      shipmentMethods: shipMethods,
      smsSignUp: { sendOrderUpdate: checkBoxState },
    };
    const { phoneNumber } = updatedValues;
    const savedAdressForPaylaod = {
      ...updatedValues,
    };
    const payload = formatPayloadForMelissa({
      ...savedAdressForPaylaod,
      isExpanded: false,
      mode: SECTION_MODE.SECTION_VIEW_MODE,
      formName: SHIPPING_FORM_NAME,
      giftServicesDetails: { ...giftServicesInput },
    });

    const optimizedPayload = shipments
      ?.filter((item) => item?.itemsCount > 0)
      ?.map((item) => ({
        shipmentId: item.shipmentId,
        c_vibesSmsPhoneNo: checkBoxState ? item?.shippingAddress?.phone?.replace(/\D/g, '') : '',
      }));
    if (
      giftServicesInput?.optionId?.search(GIFT_SERVICES_CONSTANTS.GIFT_SERVICES_NONE_VALUE) !== -1
    ) {
      dispatchGiftFormFieldChange('hasGiftWrapping', false);
    }
    if (smsUpdatesAPIOptimization) {
      setSMSUpdatesAction(optimizedPayload);
    } else {
      saveAddressFromMelissa(payload);
    }
    setShippingFormValuesInSS({ smsSignUp: { sendOrderUpdate: checkBoxState }, phoneNumber });
    updateSectionState({
      id: SPC_SECTION.SHIPPING,
      section: { smsSignUp: { sendOrderUpdate: checkBoxState }, phoneNumber },
    });
  };

  const isSmsSignUp = contactFormData?.smsSignUp?.sendOrderUpdate;
  useEffect(() => {
    if (shippingReduxForm?.submitFailed) {
      handleClickOutside();
    }
  }, [shippingReduxForm?.submitFailed]);

  const isSaveDisabled =
    isLoadingShippingMethods ||
    !isShippingSectionFilled(shippingFormInput, shipmentMethods, isLoginV2FlowEnabled);

  const collapsedViewProps =
    holidayMessageEnabled || isGiftServiceVisible || isShippingMethodsOnShippingEnabled
      ? {
          shipmentMethods,
          isPlccIC,
          section,
          formName,
          selectedShipmentId,
          dispatchFormFieldChange,
          isLoadingShippingMethods,
          isUpdatingShipmentMethods,
          updateShipmentMethods,
          shippingFormInput,
          savedAddress,
          handleSaveAndContinueShipping,
          giftServicesInput,
          holidayMessageEnabled,
          isGiftServiceVisible,
          loadShipmentMethods,
          isShake: clickedOutsideShippingFlag,
          isSaveDisabled,
          saveBtnLoadingStatus,
          addressFormLabels,
          sfsError,
          cartOrderItems,
          globalLabels,
          setSFSErrors,
          dispatchGiftFormFieldChange,
          addSFSItemsToSFL,
        }
      : {};

  const ref = useRef();
  const { autoSuggestMode, isActive, disabled } = section;
  const handleEdit = () => {
    setSMSCheckBoxState(isSmsCheckboxChecked);
    setTimeout(() => {
      updateSectionState({
        isExpanded: true,
        registeredUserFormMode: REG_FORM_MODE.EDIT_ADDRESS,
        autoSuggestMode: ADDRESS_FORM_MODE.MANUAL,
        isFormExpanded: true,
        isMethodAndGiftSectionVisible: true,
      });
      fillFormOnEdit(savedAddress);
      if (isGuestUser) {
        const { state = '', zipCode = '', addressLine1 = '', addressLine2 = '' } = savedAddress;
        loadShipmentMethods({
          state,
          zipCode,
          addressField1: addressLine1,
          addressField2: addressLine2,
          formName,
        });
      }
      activateSpcSection();
    }, 600);
  };
  const onEditAddressClick = () => {
    setOpenFormForVerification(true);
    handleEdit();
    scrollAccordionCardIntoView(ref, ACCORDION_REF.SHIPPING_REF_ID);
    const fromActionPaypal = parseBoolean(getSessionStorage('fromActionPaypal'));
    if (fromActionPaypal) {
      removeSessionStorage('fromActionPaypal');
    }
  };
  const handleCancel = () => {
    const { phoneCountryCode } = savedAddress;
    setPhoneCountryAction(phoneCountryCode);
    setTimeout(() => {
      if (orderTrackingEnhancementEnabled) {
        updateSectionState({
          isExpanded: false,
          mode: SECTION_MODE.SECTION_VIEW_MODE,
          registeredUserFormMode: REG_FORM_MODE.SAVED_ADDRESS,
          isFormExpanded: false,
        });
      } else {
        updateSectionState({ isExpanded: false, mode: SECTION_MODE.SECTION_VIEW_MODE });
      }

      recalibrateSectionStates();
      if (isMakeDefaultUxUpdateEnabled) {
        makeDefaultAddress(false);
      }
    }, 0);
  };
  const handleSave = () => {
    if (!isUpdatingShipmentMethods) {
      triggerFormSubmit();
    }
    if (isPlccIC) {
      plccShippingAddressUpdateActn(true);
    }
  };

  function debounce(fn, delay) {
    let timer = null;
    return () => {
      timer = setTimeout(() => {
        fn();
        clearTimeout(timer);
      }, delay);
    };
  }

  const debouncedFunction = debounce(handleSave, 50);

  const shippingHeader = HeaderComponent({
    section,
    savedAddress,
    updateSectionState,
    handleEdit,
    handleCancel,
    venmoPayInProgress,
    isExpanded,
    venmoLabels,
    isGuestUser,
    isPlccIC,
    addressFormLabels,
    bossSwitchEnabled,
    shippingReduxForm,
  });
  const isDefaultChanged = getIsDefaultChanged(defaultAddress, shippingFormInput);
  const checkSMSCheckBoxState = isExpanded ? smsCheckBoxState : isSmsSignUp;
  const validateAddressWithMelissa = () => {
    verifyAddressAction(
      formatPayloadForMelissa({
        ...savedAddress,
        formName,
      })
    );
  };
  const showSMSCheckBoxCont =
    smsPhoneCountryCode === '+1' || registeredUserFormMode === REG_FORM_MODE.ADD_NEW_ADDRESS;
  const smsSubscriptionStatus = parseBoolean(readCookie('smsSubscriptionStatus')) || false;

  return (
    <>
      {nonCacheBagLoading ? (
        <ShippingCardSkeleton />
      ) : (
        <AccordionCard
          header={shippingHeader}
          cardClassName={`${className} shipping-accordion`}
          isExpanded={isExpanded}
          ref={ref}
          isActive={isActive}
          accordionCardRefId={ACCORDION_REF.SHIPPING_REF_ID}
          transitionConfig={SPC_SECTION_TRANSITION_CONFIG[section.id]}
          recalculateHeight={section?.isFormExpanded}
          bossSwitchEnabled={bossSwitchEnabled}
        >
          {(isExpanded || isPlccIC) && (
            <ShippingExpanded
              formName={formName}
              isPlccIC={isPlccIC}
              mode={autoSuggestMode}
              savedAddress={savedAddress}
              addressFormLabels={addressFormLabels}
              pristine={pristine}
              dirty={dirty}
              invalid={invalid}
              isSaveDisabled={isSaveDisabled}
              updateSectionState={updateSectionState}
              selectedShipmentId={selectedShipmentId}
              shipmentMethods={shipmentMethods}
              loadShipmentMethods={loadShipmentMethods}
              updateShipmentMethods={updateShipmentMethods}
              handleSave={debouncedFunction}
              giftWrapOptions={giftWrapOptions}
              labels={labels}
              giftServicesInput={giftServicesInput}
              savedGiftService={savedGiftService}
              globalLabels={globalLabels}
              section={section}
              saveBtnLoadingStatus={saveBtnLoadingStatus}
              orderEddDates={orderEddDates}
              venmoPayInProgress={venmoPayInProgress}
              ShippingFormRef={ShippingFormRef}
              setCheckoutClientError={setCheckoutClientError}
              cartOrderItems={cartOrderItems}
              sfsError={sfsError}
              dispatchFormFieldChange={dispatchFormFieldChange}
              setSFSErrors={setSFSErrors}
              dispatchGiftFormFieldChange={dispatchGiftFormFieldChange}
              addSFSItemsToSFL={addSFSItemsToSFL}
              isLoginV2FlowEnabled={isLoginV2FlowEnabled}
              isShake={clickedOutsideShippingFlag}
              shippingReduxForm={shippingReduxForm}
              isMakeDefaultUxUpdateEnabled={isMakeDefaultUxUpdateEnabled}
              makeDefaultAddress={makeDefaultAddress}
              defaultAddress={defaultAddress}
              isDefaultChanged={isDefaultChanged}
              className={className}
              isGcEnabledOnBagSection={isGcEnabledOnBagSection}
              orderTrackingEnhancementEnabled={orderTrackingEnhancementEnabled}
              smsCheckBoxState={smsCheckBoxState}
              openFormForVerification={openFormForVerification}
              setOpenFormForVerification={setOpenFormForVerification}
            />
          )}
          {!isExpanded && !isPlccIC && isAddressSaved(savedAddress) && (
            <ShippingCollapsed
              address={savedAddress}
              giftServicesLabels={giftServicesLabels}
              savedGiftService={savedGiftService}
              giftWrapOptions={giftWrapOptions}
              orderEddDates={orderEddDates}
              selectedShipment={shippingMethodSelected}
              isLoginV2FlowEnabled={isLoginV2FlowEnabled}
              shouldShowShipmentMethodsCollapsed={shouldShowShipmentMethodsCollapsed}
              freeShippingThershold={freeShippingThershold}
              shippingTotal={shippingTotal}
              isDynamicFreeShippingEnabled={isDynamicFreeShippingEnabled}
              shipments={shipments}
              orderType={orderType}
              productTotal={productTotal}
              isSmsSignedUp={isSmsSignedUp}
              isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
              orderTrackingEnhancementEnabled={orderTrackingEnhancementEnabled}
              validateAddressWithMelissa={validateAddressWithMelissa}
              isAddressVerificationBadgeEnabled={isAddressVerificationBadgeEnabled}
              isGcEnabledOnBagSection={isGcEnabledOnBagSection}
              contactFormData={contactFormData}
              updateSectionState={updateSectionState}
              isShippingMethodsOnShippingEnabled={isShippingMethodsOnShippingEnabled}
              isShowShipmentMethodInCollapsed={isShowShipmentMethodInCollapsed}
              {...collapsedViewProps}
            />
          )}
          <AddressVerification
            onSuccess={saveAddressFromMelissa}
            heading="Verify Address"
            onError={saveAddressFromMelissa}
            shippingAddress={formatPayloadForMelissa({
              ...shippingFormInput,
              formName,
              ...(isMakeDefaultUxUpdateEnabled && isDefaultChanged
                ? { defaultShipping: isDefaultChanged }
                : {}),
            })}
            spc
            showIndicatorIcon
            onEditAddressClick={onEditAddressClick}
          />
          {orderTrackingEnhancementEnabled && !disabled && showSMSCheckBoxCont && (
            <div className="sms-updates-wrapper">
              {!smsSubscriptionStatus || !isSMSUpdatesSingleOptInEnabled ? (
                <div className={`sms-updates-container ${checkSMSCheckBoxState && 'elem-mb-XS_1'}`}>
                  <BodyCopy
                    component="div"
                    fontSize={isMobileWeb() ? 'fs13' : 'fs14'}
                    fontWeight="bold"
                    fontFamily="secondary"
                  >
                    {smsSignUpLabels?.orderUpdates}
                  </BodyCopy>

                  <InputCheckbox
                    execOnChangeByDefault={false}
                    className="check-box"
                    input={{
                      onChange: isExpanded ? handleChange : handleChangeWithApiCall,
                      value: checkSMSCheckBoxState,
                    }}
                  />
                </div>
              ) : (
                <div className="sms-subscription-confirmation">
                  <Image
                    className="success-sms-subscribed-icon elem-mr-SM"
                    width={24}
                    height={24}
                    src={getIconPath('orders')}
                    alt="success-sms-subscribed"
                  />
                  <BodyCopy
                    component="div"
                    fontSize={isMobileWeb() ? 'fs13' : 'fs14'}
                    fontWeight="bold"
                    fontFamily="secondary"
                  >
                    {getDynamicLabelValues('dynamic.checkout_d.lbl_order_updates_subscribed')}
                  </BodyCopy>
                </div>
              )}

              {checkSMSCheckBoxState && !smsSubscriptionStatus && (
                <BodyCopy
                  component="div"
                  fontSize={isMobileWeb() ? 'fs10' : 'fs12'}
                  fontFamily="secondary"
                >
                  {smsSignUpLabels?.smsSignupText}
                </BodyCopy>
              )}
            </div>
          )}
        </AccordionCard>
      )}
    </>
  );
};

Shipping.propTypes = {
  formName: PropTypes.string.isRequired,
  section: PropTypes.shape({}).isRequired,
  addressFormLabels: PropTypes.shape({}).isRequired,
  triggerFormSubmit: PropTypes.func.isRequired,
  shippingFormInput: PropTypes.shape({}).isRequired,
  pristine: PropTypes.bool,
  dirty: PropTypes.bool,
  invalid: PropTypes.bool,
  updateSectionState: PropTypes.func.isRequired,
  fillFormOnEdit: PropTypes.func.isRequired,
  shipmentMethods: PropTypes.shape({}),
  selectedShipmentId: PropTypes.string,
  loadShipmentMethods: PropTypes.func.isRequired,
  updateShipmentMethods: PropTypes.func.isRequired,
  labels: PropTypes.shape({}).isRequired,
  giftWrapOptions: PropTypes.shape({}).isRequired,
  saveAddressFromMelissa: PropTypes.func.isRequired,
  giftServicesInput: PropTypes.shape({}).isRequired,
  giftServicesLabels: PropTypes.shape({}).isRequired,
  savedAddress: PropTypes.shape({}),
  savedGiftService: PropTypes.shape({}),
  globalLabels: PropTypes.shape({}).isRequired,
  saveBtnLoadingStatus: PropTypes.bool,
  nonCacheBagLoading: PropTypes.bool,
  isGuestUser: PropTypes.bool,
  activateSpcSection: PropTypes.func.isRequired,
  recalibrateSectionStates: PropTypes.func.isRequired,
  orderEddDates: PropTypes.shape({}),
  venmoPayInProgress: PropTypes.bool.isRequired,
  shippingMethodSelected: PropTypes.shape({}),
  isPaypalPostBack: PropTypes.bool,
  className: PropTypes.string.isRequired,
  isLoginV2FlowEnabled: PropTypes.bool,
  clickedOutsideShippingFlag: PropTypes.bool,
  isMakeDefaultUxUpdateEnabled: PropTypes.bool,
};

Shipping.defaultProps = {
  pristine: false,
  dirty: false,
  invalid: false,
  shipmentMethods: [],
  selectedShipmentId: '',
  savedAddress: {},
  savedGiftService: {},
  saveBtnLoadingStatus: false,
  isGuestUser: false,
  nonCacheBagLoading: false,
  orderEddDates: {},
  shippingMethodSelected: {},
  isPaypalPostBack: false,
  isLoginV2FlowEnabled: false,
  isMakeDefaultUxUpdateEnabled: false,
};

HeaderComponent.propTypes = {
  section: PropTypes.shape({}).isRequired,
  updateSectionState: PropTypes.func.isRequired,
  savedAddress: PropTypes.shape({}),
  handleEdit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  venmoPayInProgress: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  labels: PropTypes.shape({}).isRequired,
  isGuestUser: PropTypes.bool,
};
HeaderComponent.defaultProps = {
  savedAddress: {},
  isGuestUser: false,
};

export default withStyles(Shipping, styles);
